// extracted by mini-css-extract-plugin
export default {"root":"Banner_root__3PWJT","content":"Banner_content__Nyjud","limit":"Banner_limit__8IA19","close":"Banner_close__j0CiU"};